import { observer } from "mobx-react";
import CreateRmaSettingsStore from "../stores/create-rma-settings-store";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../components/fonts/font-props";
import { DROPDOWN_MENU_WIDTH, IOption, SelectDropdown } from "../../../components/inputs/select-dropdown/select-dropdown";
import { CREATE_RMA_MODE } from "../../../services/api/create-rma-service";
import './create-rma-mode-selector.scss';
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";

interface ICRmaModeSelectorProps {
    createRmaSettingsStore: CreateRmaSettingsStore;
}

const CreateRmaModeSelector: React.FC<ICRmaModeSelectorProps> = observer(({createRmaSettingsStore}) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-create-rma';

    const modeOptions: IOption[] = createRmaSettingsStore.getCRmaModeOptions().map((mode): IOption => {
        return {
            label: getTranslation(mode.labelTranslationKey, scope),
            value: mode.value,
        };
    });
    if (modeOptions.length === 0) {
        return null;
    }

    const selectedMode = modeOptions.find(option => option.value === createRmaSettingsStore.cRmaMode);
    const disabled = modeOptions.length <= 1;

    return (
        <div className="c-rma-mode-selector">
            <FontBody2 variant={FONT_VARIANT.BOLD}>{getTranslation('MODE', scope)}</FontBody2>
            <SelectDropdown 
                isSearchable={false}
                options={modeOptions}
                value={selectedMode}
                onChange={v => createRmaSettingsStore.setCRmaMode(v?.value as CREATE_RMA_MODE)}
                menuWidth={DROPDOWN_MENU_WIDTH.MAX_CONTENT}
                disabled={disabled}
            />
        </div>
    )
});

export default CreateRmaModeSelector;